import React, { useState } from "react";
import { CSSProperties } from "react";
import { colors, fonts } from "../../Styles";
import { DataValue } from "../../Definitions";

interface ToolTipStringProps {
  content: DataValue['value']
  tooltipString?: string
  overrides?: {
    string?: CSSProperties
    tooltipString?: CSSProperties
    tooltipBgColor?: colors
    contentCursor?: CSSProperties
  }
}

export default function ToolTipString({tooltipString, content, overrides }:ToolTipStringProps) {
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const _stringOverrides = overrides&&overrides?.string ? overrides.string : {...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary}
  const _tooltipStringOverrides = overrides&&overrides?.tooltipString ? overrides.tooltipString : {...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary}
  const _contentCursor = overrides&&overrides?.contentCursor ? overrides.contentCursor : {cursor: "default"}

  const TOOLTIP_COLOR = overrides?.tooltipBgColor ? overrides?.tooltipBgColor : colors.greyDarkPrimary

  return ( <>
    <div style={{zIndex: "2", position: "relative", width: "fit-content", height: "fit-content"}}>
      <div style={{..._contentCursor, ..._stringOverrides}} 
        onMouseEnter={tooltipString ? () => setShowTooltip(true) : undefined} 
        onMouseLeave={tooltipString ? () => setShowTooltip(false) : undefined}
      >
          {content}
      </div>
      {showTooltip && <div>
        <div style={{zIndex: "1", position: "absolute", transform: "translate(-50%, 0%)", top: "-32px", left: "50%", width: "fit-content", height: "fit-content", backgroundColor: TOOLTIP_COLOR, borderRadius: "10px", boxSizing: "border-box", padding: "5px 10px"}}>
          <p style={{whiteSpace: "nowrap", ..._tooltipStringOverrides}}>{tooltipString}</p>
        </div>
        <div style={{zIndex: "0", position: "absolute", transform: "translate(-50%, 0%)", top: "-14px", left: "50%", width: "15px", height: "15px", rotate: "45deg", backgroundColor: TOOLTIP_COLOR}}/>
      </div> }
    </div>
  </> )
}